import { useEffect } from 'react';

/**
 * Custom hook that uses IntersectionObserver to reveal elements
 * with the 'reveal', 'reveal-left', 'reveal-right', or 'reveal-scale' classes
 * when they enter the viewport. Handles dynamic DOM changes.
 */
export default function useScrollReveal() {
  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -80px 0px',
      threshold: 0.1,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    const observeElements = () => {
      const revealElements = document.querySelectorAll(
        '.reveal:not(.revealed), .reveal-left:not(.revealed), .reveal-right:not(.revealed), .reveal-scale:not(.revealed)'
      );
      revealElements.forEach((el) => observer.observe(el));
    };

    // Initial observation
    observeElements();

    // Observe DOM mutations for dynamic elements
    const mutationObserver = new MutationObserver(() => {
      observeElements();
    });

    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => {
      observer.disconnect();
      mutationObserver.disconnect();
    };
  }, []);
}
